export default "__VITE_ASSET__ZlUOoDiD__"